import React from 'react';
import { ArrowUpRight, CheckCircle2, Clock3, ShieldCheck } from 'lucide-react';

import AIConfidenceIndicator from './AIConfidenceIndicator';

const statusTone = {
  approved: 'text-emerald-300 bg-emerald-500/10 border-emerald-500/20',
  pending: 'text-amber-300 bg-amber-500/10 border-amber-500/20',
  in_review: 'text-sky-300 bg-sky-500/10 border-sky-500/20',
};

const statusIcon = {
  approved: CheckCircle2,
  pending: Clock3,
  in_review: ShieldCheck,
};

const AIRecommendationPanel = ({ rows = [], variant = 'dark', onRowClick }) => {
  const isLight = variant === 'light';
  const buildRowHandlers = (row) => {
    if (typeof onRowClick !== 'function') {
      return {};
    }
    return {
      role: 'button',
      tabIndex: 0,
      onClick: () => onRowClick(row),
      onKeyDown: (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onRowClick(row);
        }
      },
    };
  };
  return (
    <div className="space-y-3">
      {rows.map((row, index) => {
        const StatusIcon = statusIcon[row.status] || Clock3;
        return (
          <div
            key={row.id}
            className={isLight ? `animate-slide-up rounded-2xl border border-border bg-card p-4 text-foreground transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/30 hover:bg-muted ${typeof onRowClick === 'function' ? 'cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/40' : ''}` : `animate-slide-up rounded-2xl border border-slate-700/80 bg-slate-950/90 p-4 text-slate-100 transition-all duration-200 hover:-translate-y-0.5 hover:border-cyan-400/20 hover:bg-slate-900/95 ${typeof onRowClick === 'function' ? 'cursor-pointer focus:outline-none focus:ring-2 focus:ring-cyan-400/40' : ''}`}
            style={{ animationDelay: `${index * 0.05}s` }}
            {...buildRowHandlers(row)}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className={`text-sm font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{row.title}</p>
                <p className={`mt-2 text-sm ${isLight ? 'text-foreground' : 'text-slate-200'}`}>{row.rationale || row.summary}</p>
              </div>
              <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-medium capitalize ${statusTone[row.status] || statusTone.pending}`}>
                <StatusIcon className="h-3.5 w-3.5" />
                {String(row.status || 'pending').replace('_', ' ')}
              </span>
            </div>
            <div className="mt-4 grid gap-3 sm:grid-cols-2">
              <AIConfidenceIndicator value={row.confidence_score} variant={variant} />
              <div className={isLight ? 'rounded-xl border border-border bg-muted p-3' : 'rounded-xl border border-slate-700/80 bg-slate-800/70 p-3'}>
                <div className={`flex items-center justify-between text-xs uppercase tracking-[0.18em] ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>
                  <span>Impact Score</span>
                  <ArrowUpRight className={`h-3.5 w-3.5 ${isLight ? 'text-primary' : 'text-cyan-200'}`} />
                </div>
                <p className={`mt-2 text-2xl font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{Number(row.impact_score || 0).toFixed(1)}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AIRecommendationPanel;
